import React from 'react';

export default function Footer() {
  return (
    <footer className='p-3 font-medium'>Ricardo - All rights reserved ®</footer>
  );
}
